const controllers = require('./../Http/Controllers')


const routes = {
  home: {
    component: controllers.HomepageController,
    path: '/:locale?',
    name: 'home',
  },
  projects: {
    component: controllers.ProjectsController,
    path: '/:locale/projects/:domain',
    name: 'projects',
  },
  project: {
    component: controllers.ProjectController,
    path: '/:locale/project/:slug',
    name: 'project',
  },
  studio: {
    component: controllers.StudioController,
    path: '/:locale/studio',
    name: 'studio',
  },
  legalNotice: {
    component: controllers.LegalNoticeController,
    path: '/:locale/legals',
    name: 'legals',
  },
}

module.exports = routes
